export const userSessionCookie = 'cv_user'
export const fbLoginCookie = 'playment.fbLogin'
export const cvRefreshTokenCookieName = 'rt_cv'
export const refreshTokenCookieName = 'lbairt_cv'
